var React = require('react');

function JusticeOfThePeaceInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M32 4v54.686M23 59h18m-1-25h14c-.634 3.418-3.527 6-7 6s-6.366-2.582-7-6zm-30 0h14c-.634 3.418-3.527 6-7 6s-6.366-2.582-7-6z","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M17 34V14a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v20","key":1})]));
}

JusticeOfThePeaceInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = JusticeOfThePeaceInline;

JusticeOfThePeaceInline.default = JusticeOfThePeaceInline;
